import React, {useEffect, useMemo, useState} from 'react'
import ProductRegistrationOrganizationListStyle from 'pages/ProductRegistrationOrganization/ProductRegistrationOrganizationList/style'
import Table from '@material-ui/core/Table'
import {useTranslation} from 'react-i18next'
import Checkbox from '@material-ui/core/Checkbox'
import SearchBar from 'components/Forms/SearchBar'
import Pagination from 'components/molcules/Pagination'
import {
  makeStyles,
  TableCell,
  TableHead,
  TableBody,
  TableRow,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  Button,
} from '@material-ui/core'

import {
  LIST_COLUMN_TABLE,
  SELECT_ORGANIZATION,
} from 'pages/ProductRegistrationOrganization/constant'

import {
  FetchListOrgCanSellProductRequest,
  getLicenseDetailByOrg,
  registerProductAssignLicenseApi,
} from 'api/productApi'
import TableLoading from 'components/Table/TableLoading'
import TableEmpty from 'components/Table/TableEmpty'
import useFailureModal from 'features/modal/useFailureModal'
import useOrgLicenseRegister from 'features/org/useOrgLicenseRegister'
import {dateToDashString, formatDate} from 'helpers/dateHelper'
import DialogConfirm from 'pages/LicenseAnalysisOrganization/Component/DialogConfirm'
import useSuccessModal from 'features/modal/useSuccessModal'
import {LICENSE_STATUS} from 'pages/ProductOperationOrganization/constant'

type TableColumn = {
  id: number
  orgName: string
  account: string
  representative: string
  activeProduct: string
  usePeriod: string
  remark: string
}

type SectionInstitutionProps = {
  goodsId: string
  name: string
  period: string | number
  // sale: number[]
}

const useStyles = makeStyles(ProductRegistrationOrganizationListStyle)
const SectionInstitution = (props: SectionInstitutionProps) => {
  const classes = useStyles()
  const {t} = useTranslation()
  const {goodsId, name, period} = props
  const [showConfirm, setShowConfirm] = useState<boolean>(false)
  const {
    onSearch,
    loading,
    listOrgCanRegister,
    totalPages,
    query,
    error,
    resetQuerySearch,
    changeQuery,
  } = useOrgLicenseRegister()
  const {onOpen} = useFailureModal()
  const [institution, setInstitution] = useState<TableColumn[]>([])
  const [searchBy, setSearchBy] = useState<'orgName' | 'email'>('orgName')
  const [selectOrg, setSelectOrg] = useState<number[]>([])
  const [oldSelOrg, setOldSelOrg] = useState<number[]>([])
  const {onOpen: onSuccessModalOpen} = useSuccessModal()
  const [listOrgChange, setListOrgChange] = useState<string[]>([])

  const emptyRows = institution.length === 0 ? 5 : 5 - institution.length

  const handleChangeCheckOrg = (selectId: number) => {
    if (selectOrg.includes(selectId)) {
      setSelectOrg(selectOrg.filter((id) => id !== selectId))
    } else {
      setSelectOrg([...selectOrg, selectId])
    }
  }
  const handleChangeCheckAllOrg = (isChecked: boolean) => {
    if (isChecked) {
      const allOrgIds = institution.map((org) => org.id)
      setSelectOrg(allOrgIds)
    } else {
      setSelectOrg([])
    }
  }

  const handleValue = (value: string) => {
    resetQuerySearch()
    changeQuery(searchBy, value)
  }

  const isChangedRegister = useMemo(() => {
    return JSON.stringify(selectOrg) !== JSON.stringify(oldSelOrg)
  }, [selectOrg, oldSelOrg])

  const formatDatePeriod = (date: number) => {
    return formatDate(new Date(date))
  }

  const onOpenConfirmDialog = () => {
    const addOrgIds = selectOrg.filter((id) => !oldSelOrg.includes(id))

    const listNameAdd = institution
      .filter((org) => addOrgIds.includes(org.id))
      .map((org) => org.orgName)
    setListOrgChange(listNameAdd)
    setShowConfirm(true)
  }

  const handleGetListOrganizationCanRegistration = async () => {
    try {
      const payloadData: FetchListOrgCanSellProductRequest = {
        goodsId,
        payload: {
          page: query.page || 0,
          size: query.size || 10,
          orgName: query.orgName,
          email: query.email,
        },
      }
      onSearch(payloadData)
    } catch (error) {
      console.log('error,', error)
    }
  }
  const handleConfirm = async (
    startDate: Date | null,
    endDate: Date | null,
  ) => {
    try {
      const addOrgIds = selectOrg.filter((id) => !oldSelOrg.includes(id))

      if (addOrgIds.length > 0) {
        await registerProductAssignLicenseApi({
          goodsId,
          orgIds: addOrgIds,
          ...(startDate && {licenseStartDate: dateToDashString(startDate)}),
          ...(endDate && {licenseEndDate: dateToDashString(endDate)}),
        })
      }
      handleGetListOrganizationCanRegistration()
      onSuccessModalOpen(t('ISuccess'))
    } catch (error) {
      onOpen(error?.message || t('IError'))
    }
  }

  const handleSearch = () => {
    handleGetListOrganizationCanRegistration()
  }
  useEffect(() => {
    if (goodsId?.length > 0) {
      resetQuerySearch()
    }
  }, [goodsId])

  const getListOrgLicenses = async () => {
    const orgIdParams = new URLSearchParams({
      orgIds: listOrgCanRegister.map((item) => item.org.id).join(','),
    })
    const listLicenseByOrg = await getLicenseDetailByOrg(orgIdParams)
    const convertDataOrgDisplay = listOrgCanRegister.map((item) => {
      const hasLicenseApplied = listLicenseByOrg.data
        .filter((license) => license.status !== LICENSE_STATUS.DESTROYED)
        .find(
          (license) =>
            license.orgId === item.org.id.toString() &&
            license.goodsId === goodsId &&
            license.deactivationDateTime > new Date().getTime(),
        )
      const periodFormat = hasLicenseApplied
        ? `${formatDatePeriod(
            Number(hasLicenseApplied?.activationDateTime),
          )} ~ ${formatDatePeriod(
            Number(hasLicenseApplied?.deactivationDateTime),
          )}`
        : String(period)

      return {
        id: item.org.id,
        orgName: item.org.name,
        account: item.chiefUser ? item.chiefUser.email : '',
        representative: item.chiefUser
          ? item.chiefUser.firstName + item.chiefUser.lastName
          : '',
        activeProduct: name,
        usePeriod: periodFormat,
        remark: '',
      }
    })
    setInstitution(convertDataOrgDisplay)
    setSelectOrg(
      listLicenseByOrg.data
        .filter(
          (item) =>
            item.goodsId === goodsId &&
            item.deactivationDateTime > new Date().getTime() &&
            item.status !== LICENSE_STATUS.DESTROYED,
        )
        .map((item) => Number(item.orgId)),
    )
    setOldSelOrg(
      listLicenseByOrg.data
        .filter(
          (item) =>
            item.goodsId === goodsId &&
            item.deactivationDateTime > new Date().getTime() &&
            item.status !== LICENSE_STATUS.DESTROYED,
        )
        .map((item) => Number(item.orgId)),
    )
  }

  useEffect(() => {
    if (goodsId?.length > 0) {
      handleGetListOrganizationCanRegistration()
    }
  }, [goodsId, query.page, query.size])

  useEffect(() => {
    if (listOrgCanRegister.length > 0) {
      getListOrgLicenses()
    }
  }, [listOrgCanRegister])

  return (
    <div
      style={{display: goodsId.length > 0 ? 'block' : 'none'}}
      className={classes.sectionInstitution}
    >
      <div className={classes.detailProduct}>
        <div className={classes.cardTitle}>■ {t('ISelectInstitution')}</div>
        <div className={classes.toolBar}>
          <FormControl variant='outlined'>
            <Select
              value={searchBy}
              onChange={(event: React.ChangeEvent<{value: unknown}>) => {
                setSearchBy(event.target.value as 'orgName' | 'email')
              }}
              style={{height: '40px'}}
              input={<OutlinedInput name='age' id='outlined-age-simple' />}
            >
              {SELECT_ORGANIZATION.map((item) => (
                <MenuItem value={item.value} key={item.value}>
                  {t(item.label)}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <SearchBar
            value={query[searchBy]}
            onChangeValue={handleValue}
            onSearchEvent={handleSearch}
            disabledValue={false}
          />
          <div
            style={{
              marginLeft: 'auto',
            }}
          >
            <Button
              color='primary'
              disabled={!isChangedRegister}
              variant='contained'
              onClick={onOpenConfirmDialog}
            >
              {t('IRegisterAnalysisLicense')}
            </Button>
          </div>
        </div>

        <Table size='small' className={classes.table}>
          <TableHead className={classes.tableHeader}>
            {LIST_COLUMN_TABLE.map((item) => (
              <TableCell
                align='center'
                key={item.key}
                style={{
                  whiteSpace: 'pre',
                }}
              >
                {item.key === 'checkbox' ? (
                  <Checkbox
                    checked={selectOrg.length === institution.length}
                    disabled={oldSelOrg.length === institution.length}
                    onChange={(e) => {
                      handleChangeCheckAllOrg(e.target.checked)
                    }}
                  />
                ) : (
                  t(item.label)
                )}
              </TableCell>
            ))}
          </TableHead>
          <TableBody>
            {institution.map((row: TableColumn) => (
              <TableRow key={row.id} className={classes.rowCell}>
                {LIST_COLUMN_TABLE.map((col) => (
                  <TableCell key={col.key} align='center'>
                    {col.key === 'checkbox' ? (
                      <Checkbox
                        checked={selectOrg.includes(row.id)}
                        disabled={oldSelOrg.includes(row.id)}
                        onChange={() => handleChangeCheckOrg(row.id)}
                      />
                    ) : (
                      row[col.key as keyof TableColumn]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
            <TableLoading loading={loading} emptyRows={emptyRows} />
            <TableEmpty
              emptyRows={emptyRows}
              loading={loading}
              error={error}
              isEmpty={institution.length === 0}
            />
          </TableBody>
        </Table>
        <Pagination
          totalPageCount={totalPages}
          currentPageIndex={query.page || 0}
          itemCountPerPage={query.size || 10}
          setCurrentPageIndex={(e) => changeQuery('page', e)}
          onItemCountPerPageChanged={(e) =>
            changeQuery('size', e.target.value as number)
          }
          loading={loading}
        />
        <DialogConfirm
          open={showConfirm}
          onClose={() => setShowConfirm(false)}
          onConfirm={handleConfirm}
          productName={name}
          listRegister={listOrgChange}
        />
      </div>
    </div>
  )
}
export default SectionInstitution
